/**
 * 現在のURLパスからアプリのベースパスを判定する
 * /app/ で始まる場合は "/app"、それ以外は "" を返す
 */
export function getBasePath(): string {
  const pathname = window.location.pathname;

  if (pathname.startsWith("/app/") || pathname === "/app") {
    return "/app";
  }

  return "";
}

/**
 * ベースパス付きの完全URLを生成
 */
export function getBaseUrl(): string {
  return `${window.location.origin}${getBasePath()}`;
}
